export default function FormField({ label, children, className = 'form-group', labelClassName }) {
  return (
    <div className={className}>
      <label className={labelClassName}>{label}</label>
      {children}
    </div>
  );
}
